import { api } from './client'
import { withCustomerIds } from './params'

const REPORT_PATHS = {
  'software-audit': '/reports/software-audit',
  'patch-status': '/reports/patch-status',
  'hardware-summary': '/reports/hardware-summary',
  'asset-list': '/reports/asset-list',
  'alerts-summary': '/reports/alerts-summary',
  'os-breakdown': '/reports/os-breakdown',
  'security-summary': '/reports/security-summary',
}

export function fetchReport(slug, params = {}, customerIds = []) {
  const path = REPORT_PATHS[slug]
  if (!path) throw new Error('Unknown report')
  return api.get(path, { params: withCustomerIds(params, customerIds) }).then((r) => r.data)
}

export function fetchPatchDetails(status, customerIds = []) {
  return api
    .get('/reports/patch-details', {
      params: withCustomerIds({ status }, customerIds),
    })
    .then((r) => r.data)
}

export function fetchOsDevices(osName, customerIds = []) {
  return api
    .get('/reports/os-devices', {
      params: withCustomerIds({ os_name: osName }, customerIds),
    })
    .then((r) => r.data)
}

export async function exportReportCsv(slug, customerIds = []) {
  const response = await api.post(
    '/reports/export',
    { report: slug, format: 'csv', customer_ids: customerIds.length ? customerIds : null },
    { responseType: 'blob' },
  )
  const url = window.URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = url
  link.download = `${slug}.csv`
  link.click()
  window.URL.revokeObjectURL(url)
}
